import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav nav-pills" }
const _hoisted_2 = { class: "nav-link" }
const _hoisted_3 = { class: "nav-link" }
const _hoisted_4 = { class: "nav-link" }
const _hoisted_5 = { class: "nav-link" }
const _hoisted_6 = { class: "nav-link" }
const _hoisted_7 = { class: "nav-link" }

import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'

    // ---------------- props ----------------
    // keep original prop names – template relies on them

    
export default /*@__PURE__*/_defineComponent({
  __name: 'GoalNavigation',
  props: {
    WorkspaceId: {},
    ProjectId: {},
    EvalModelId: {},
    ScoringEnabled: { type: Boolean },
    ActivePage: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- routing ----------------

    const route = useRoute()

    // ---------------- derived (urls) ----------------

    const url_CriteriaPage = computed(() =>
        dynamicUiRoutes.Criteria_CriteriaPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_RankingPage = computed(() =>
        dynamicUiRoutes.Evaluation_RankingPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_WeightsPage = computed(() =>
        dynamicUiRoutes.Criteria_WeightsPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_MeasurementsPage = computed(() =>
        dynamicUiRoutes.Criteria_MeasurementsPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId,
            props.ScoringEnabled
        )
    )

    const url_WeightedScoresPage = computed(() =>
        dynamicUiRoutes.Criteria_WeightedScoresPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

    const url_ScoringPanelsPage = computed(() =>
        dynamicUiRoutes.Evaluation_ScoringPanelsPage(
            route,
            props.WorkspaceId,
            props.ProjectId,
            props.EvalModelId
        )
    )

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item", {'active2': __props.ActivePage === 'criteria-hierarchy'}])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Criteria ", -1 /* CACHED */)
        ]))])), [
          [_directive_sanitizedHref, url_CriteriaPage.value]
        ])
      ], 2 /* CLASS */),
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item", {'active2': __props.ActivePage === 'measurement'}])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Measurement ", -1 /* CACHED */)
        ]))])), [
          [_directive_sanitizedHref, url_MeasurementsPage.value]
        ])
      ], 2 /* CLASS */),
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item", {'active2': __props.ActivePage === 'criteria-surveys'}])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Weights ", -1 /* CACHED */)
        ]))])), [
          [_directive_sanitizedHref, url_WeightsPage.value]
        ])
      ], 2 /* CLASS */),
      (__props.ScoringEnabled)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: _normalizeClass(["nav-item", {'active2': __props.ActivePage === 'scoring-surveys'}])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Scoring ", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, url_ScoringPanelsPage.value]
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (!__props.ScoringEnabled)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass(["nav-item", {'active2': __props.ActivePage === 'weighted-scores'}])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Scores ", -1 /* CACHED */)
            ]))])), [
              [_directive_sanitizedHref, url_WeightedScoresPage.value]
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item", {'active2': __props.ActivePage === 'results'}])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[5] || (_cache[5] = [
          _createTextVNode(" Ranking ", -1 /* CACHED */)
        ]))])), [
          [_directive_sanitizedHref, url_RankingPage.value]
        ])
      ], 2 /* CLASS */)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"0 0 60px"} }, null, -1 /* CACHED */))
  ]))
}
}

})